/*eslint-disable no-unused-vars */
/*eslint-disable quotes */
import React from 'react';
import HttpHeader from './httpheader';
import store from '../../redux/store';
const CryptoJS = require('crypto-js');

const fillKey = (key) => {
  const filledKey = Buffer.alloc(128 / 8);
  const keys = Buffer.from(key);
  if (keys.length < filledKey.length) {
    filledKey.map((b, i) => (filledKey[i] = keys[i]));
  }
  return filledKey;
};

const encrypt = (word) => {
  const privatekey = HttpHeader.getEncryptionKey();
  //let privatekey = 'bcf1dd2c04b890688a1c8ed0b2d1ffdb';

  const key = CryptoJS.enc.Utf8.parse(privatekey); //16

  let encrypted = '';

  const data = JSON.stringify(word);

  const srcs = CryptoJS.enc.Utf8.parse(data);
  encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });

  return encrypted.toString();
};

const decrypt = (word) => {
  let privatekey = HttpHeader.getEncryptionKey();
  console.log('privatekey: ', privatekey);
  //let privatekey = 'bcf1dd2c04b890688a1c8ed0b2d1ffdb';
  if (!privatekey) {
    privatekey = store.getState().key.encryptionValue.SymmetricKey;
    console.log('final private key is ', privatekey);
  }
  const key = CryptoJS.enc.Utf8.parse(privatekey);
  console.log('key: ', key);
  const decrypt = CryptoJS.AES.decrypt(word, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });

  console.log('decrypt: ', decrypt.toString(CryptoJS.enc.Utf8));
  const decryptedData = JSON.parse(decrypt.toString(CryptoJS.enc.Utf8));
  console.log('decryptedData: ', decryptedData);
  return decryptedData;
};

const apiDecrypt = (data) => {
  const privatekey = 'bcf1dd2c04b890688a1c8ed0b2d1ffdb';
  const decryptedData = decrypt(data);
  console.log('decrypted Data -');
  console.log(decryptedData);
  return decryptedData;
};
export default apiDecrypt;
